export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8985.d0c8cdb1.jpg";